import ChatColorfulIcon from "#/assets/descriptiveQuestion/ChatColorful.svg?url";
import FilledHeartIcon from "#/assets/descriptiveQuestion/contained-heart.svg?url";
import OutlinedHeartIcon from "#/assets/descriptiveQuestion/outlined-heart.svg?url";
import { useSelectedStudentIdContext } from "#/components/exam-results/context/studentsList/context";
import PersonalNoteModal from "#/components/exam-results/descriptivePage/PersonalNoteModal";
import { setQuestionLike } from "#/services/rest/gwt/exam-results/descriptive/like-question";
import { useBreakLG, useModal } from "@monta/design-system";
import { ChevronLeft } from "@monta/icons";
import clsx from "clsx";
import { type ReactNode, useEffect, useState } from "react";
import type { DqGlobalProps } from "../types";
import { useGetQuestions } from "../utils";
import styles from "./dqFooter.module.scss";

type Props = DqGlobalProps & {
  answerComponent?: ReactNode;
};

export const DescriptiveQuestionFooter = (props: Props) => {
  const { answerComponent, shouldRenderAs } = props;
  const { selectedStudentId } = useSelectedStudentIdContext();
  const { like, popularity, id } = useGetQuestions(
    selectedStudentId,
    props.id,
  )[0];
  const personalNoteModalProps = useModal();
  const isLG = useBreakLG();

  const [likeInfo, setLikeInfo] = useState({
    isLiked: false,
    likeCount: 0,
  });

  const { isLoading, mutate } = setQuestionLike.useMutation();
  const [showAnswer, setShowAnswer] = useState(false);

  useEffect(() => {
    setLikeInfo({
      isLiked: like,
      likeCount: popularity,
    });
  }, [like, popularity]);

  return (
    <footer className={styles["dq-footer"]}>
      <PersonalNoteModal {...personalNoteModalProps} questionId={id} />
      <div
        className={styles["dq-footer__answer--desktop"]}
        style={{ height: showAnswer ? "auto" : 0 }}
      >
        {isLG && answerComponent}
      </div>

      <div className={styles["dq-footer__actions"]}>
        <div className={styles["dq-footer__actions__interaction"]}>
          {shouldRenderAs === "default" && (
            <span className={styles["dq-footer__actions__interaction__panel"]}>
              <img
                src={ChatColorfulIcon}
                onClick={() => personalNoteModalProps.open()}
                alt="یادداشت"
              />
            </span>
          )}

          <span className={styles["dq-footer__actions__interaction__like"]}>
            <span>{likeInfo.likeCount}</span>

            <img
              onClick={() => {
                if (isLoading) return;

                mutate(
                  {
                    body: {
                      questionId: id,
                      disable: likeInfo.isLiked,
                    },
                  },
                  {
                    onSuccess: () => {
                      setLikeInfo((prev) => ({
                        isLiked: !prev.isLiked,
                        likeCount: prev.isLiked
                          ? prev.likeCount - 1
                          : prev.likeCount + 1,
                      }));
                    },
                  },
                );
              }}
              src={likeInfo.isLiked ? FilledHeartIcon : OutlinedHeartIcon}
              alt="لایک"
            />
          </span>
        </div>

        <div
          className={styles["dq-footer__answer--mobile"]}
          style={{ height: showAnswer ? "auto" : 0 }}
        >
          {!isLG && answerComponent}
        </div>

        <button
          onClick={() => setShowAnswer((prevState) => !prevState)}
          className={clsx(
            styles["dq-footer__actions__show-answer"],
            styles[
              `dq-footer__actions__show-answer__${showAnswer ? "expanded" : "not-expanded"}`
            ],
          )}
        >
          <span>{showAnswer ? "بستن پاسخ" : "مشاهده پاسخ"}</span>
          <ChevronLeft />
        </button>
      </div>
    </footer>
  );
};
